import {FC} from "react"
import Pagination from "./Pagination"
import EventSelectorComponent from "./EventSelectorComponent"
import OrganizationsTable from "./AdminOrganizationTableComponent"
import {AdminPageCard} from "./AdminPageCard";
import {useEventsContext} from "../../providers/EventsProvider";
import {useOrganizationsAndParticipantsContext} from "../../providers/OrganizationsAndParticipantsProvider";

export const AdminOrganizationsTable: FC = () => {
    const loadEvents = useEventsContext()
    const { organizations } = useOrganizationsAndParticipantsContext()

    return (
        <AdminPageCard title="Organizace">
            <div className="py-2">
                <div className="flex flex-col items-center">
                    {/* Container for selectors */}
                    <div className="w-full mb-4 flex justify-center md:justify-between items-center">
                        <EventSelectorComponent
                            selectedValue={loadEvents.selectedEventId ?? ""}
                            onSelect={loadEvents.setSelectedEventId}
                            events={loadEvents.events || []}
                            isLoading={loadEvents.isLoading}
                        />
                    </div>
                    <div className="container overflow-x-auto">
                        <OrganizationsTable
                            organizations={organizations}
                            events={loadEvents.events}
                            isLoading={loadEvents.isLoading}
                            selectedValue={loadEvents.selectedEventId ?? ""}
                        />
                    </div>
                    {/* Pagination below the table */}
                    {organizations.length !== 0 && loadEvents.selectedEventId !== "" && (
                        <div className="w-full px-4 mt-4">
                            <Pagination/>
                        </div>
                    )}
                </div>
            </div>
        </AdminPageCard>
    );
};
